import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { allTemplatesForTier, recentTemplates, templateLink } from '../../lib/templates'
import { store } from '../../stores/templates'
import Fuse from 'fuse.js'
import TemplateCategories from './TemplateCategories'
import TemplatesBreadcrumb from './TemplatesBreadcrumb'
import TemplatePreviews from './TemplatePreviews'
import TemplatesFilter from './TemplatesFilter'
import Template from '../Template'
import { Col, Row } from 'reactstrap'
import { Link } from 'react-router-dom'

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default function TemplatesPlan() {
  const [query, setQuery] = useState('')
  const isFiltering = query.trim() != ''

  const {
    templateCategories,
    templates,
    plans,
    hasSubscriptionAccess,
    canManageTemplates,
    basename,
    subscriptionTier,
    isAdmin,
    subscribed,
    subscriptionLink,
    selectedTemplates,
    onSelect,
    humanName,
    hideRecent,
  } = useContext(store)

  const { plan } = useParams()

  const displayTemplates = allTemplatesForTier(templates, plans[plan])

  const routeMatches = useParams()
  const currentPlan = routeMatches.plan

  const fuse = new Fuse(displayTemplates, {
    keys: ['attributes.title', 'attributes.tags'],
    threshold: 0.3,
  })

  useEffect(() => {
    document.title = `${capitalizeFirstLetter(plan)} ${humanName} | ${humanName} Library | Box Out Sports`
  }, [plan])

  const filteredTemplates = isFiltering ? fuse.search(query.trim()).map(f => f.item) : null

  const filterResults = isFiltering ? (
    <TemplatePreviews
      isAdmin={isAdmin}
      subscribed={subscribed}
      subscriptionTier={subscriptionTier}
      hasSubscriptionAccess={hasSubscriptionAccess}
      canManageTemplates={canManageTemplates}
      templates={filteredTemplates}
      templateCategories={templateCategories}
      basename={basename}
      templateLink={`/${plan}/:category/:slug`} />
  ) : null

  const normalResults = isFiltering ? null : (
    <TemplateCategories templateCategories={templateCategories} templates={templates} plans={plans} />
  )

  const allRecent = recentTemplates(templates)
  const tieredRecent = allTemplatesForTier(allRecent, plans[plan])
  const limitedRecent = tieredRecent.slice(0, 6)

  return (
    <>
      <TemplatesFilter
        subscriptionTier={subscriptionTier}
        subscribed={subscribed}
        subscriptionLink={subscriptionLink}
        isAdmin={isAdmin}
        plans={plans}
        templates={templates}
        templateCategories={templateCategories}
        onChange={setQuery} />
      { !isFiltering && !hideRecent && (
        <>
          <Row className="align-items-center mb-3">
            <Col>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                  <li className="active breadcrumb-item text-capitalize" aria-current="page">
                    Recently Released
                  </li>
                </ol>
              </nav>
            </Col>
            <Col xs="auto">
              <Link to={`/${currentPlan}/recent`} className="btn btn-primary btn-sm">
                View All Recent
              </Link>
            </Col>
          </Row>
          <div className="card-bordered graphic-container graphic-container-hscroll mb-3">
            {limitedRecent
              .map(template => (
                <Template
                  key={`template:${template.id}:${template.attributes.active}`}
                  isAdmin={isAdmin}
                  template={template}
                  templateLink={templateLink(template, basename)}
                  availableForSubscription={subscriptionTier >= template.attributes.tier}
                  hasSubscriptionAccess={hasSubscriptionAccess}
                  canManageTemplates={canManageTemplates}
                  selected={selectedTemplates?.includes(template.id)}
                  onSelect={onSelect} />
            ))}
          </div>
        </>
      )}
      <TemplatesBreadcrumb templateCategories={templateCategories} query={query} />
      {filterResults}
      {normalResults}
    </>
  )
}
